module.exports = __webpack_public_path__ + "media/images/pengurus/direktur-utama-d1a5fd0003ab63696c218290c1481615.jpeg";